let bindWorkflowState = require('./workflowStateHOC'),
    WorkflowRoot = require('./WorkflowRoot'),
    flexStoreConnector = require('./flexStoreConnector');


module.exports = (flex = window.flex) => {

    const connector = flexStoreConnector(flex);

    return (workflowId, autoRewind) => {
        return bindWorkflowState(WorkflowRoot, connector(workflowId, autoRewind));
    };
};